export const checkQueryParam = (paramName: string): boolean => {
	const searchParams = new URLSearchParams(window.location.search);
	return searchParams.has(paramName);
};
